import { setupInViewEvents } from '../../utilities/loader-events'
import { Logger } from '../../utilities/Logger'

const playEvent = 'moodVideo:in-view'
const pauseEvent = 'moodVideo:out-of-view'

export class DynamicVideoEmbed {
  constructor (elem) {
    this.logger = new Logger('Dynamic video embed')
    this.elem = elem
    this.controlID = elem.getAttribute('aria-controls')
    this.targetZone = document.getElementById(this.controlID)
    this.imageBlock = this.targetZone.parentNode.querySelector('[data-video-bg]')
    if (this.targetZone !== null) {
      this.videoType = this.targetZone.dataset.videoType
      this.videoId = this.targetZone.dataset.videoId
      this.targetZone.loading = false
      this.elem.addEventListener('click', (e) => {
        if (this.targetZone.loading === false) {
          this.loadVideo()
        }
      })
    }
  }

  loadVideo () {
    this.targetZone.loading = true
    this.elem.classList.add('loading')
    requestAnimationFrame(() => {
      const videoSource = this.compileVideoSource()
      if (videoSource) {
        this.addFrame(videoSource)
        this.elem.classList.remove('loading')
        this.elem.dataset.videoLoaded = true
        if (this.imageBlock !== null) {
          this.imageBlock.dataset.videoLoaded = true
          this.imageBlock.addEventListener('transitioned', () => {
            this.imageBlock.parentNode.removeChild(this.imageBlock)
          })
        }
        this.elem.addEventListener('transitioned', () => {
          this.elem.parentNode.removeChild(this.elem)
        })
      } else {
        this.elem.classList.remove('loading')
      }
    })
  }

  compileVideoSource () {
    switch (this.videoType) {
      case 'youtube':
        return `https://www.youtube.com/embed/${this.videoId}?autoplay=1&mute=1&rel=0&showinfo=0&controls=1&loop=1&playlist=${this.videoId}`
      case 'vimeo':
        return `https://player.vimeo.com/video/${this.videoId}?autoplay=1&title=0&muted=1&byline=0&portrait=0&loop=1&playlist=${this.videoId}`
      default:
        return false
    }
  }

  addFrame (videoSource) {
    const iframe = document.createElement('iframe')
    iframe.setAttribute('frameborder', '0')
    iframe.setAttribute('allowfullscreen', '')
    iframe.setAttribute('allow', 'autoplay; fullscreen')
    iframe.setAttribute('src', videoSource)
    iframe.setAttribute('title', 'LeShuttle video')
    iframe.classList.add('media-block__iframe')
    this.targetZone.appendChild(iframe)
    this.targetZone.classList.add('media-block__video--loaded')
    iframe.focus()
  }
}

export class MoodVideo {
  constructor (elem) {
    setupInViewEvents(elem, playEvent, pauseEvent)
    this.logger = new Logger('Mood video')
    this.targetZone = elem
    this.validUrl = true
    this.imageBlock = this.targetZone.parentNode.querySelector('[data-video-bg]')
    if (this.targetZone !== null) {
      this.videoType = this.targetZone.dataset.videoType
      this.videoId = this.targetZone.dataset.videoId
      this.targetZone.loading = false
      this.logger.log('setting up mood video')
      this.targetZone.addEventListener(playEvent, () => {
        this.logger.log('mood video in view')
        if (this.targetZone.loading === false) {
          this.loadVideo()
        }
      })
      this.targetZone.addEventListener(pauseEvent, () => {
        this.logger.log('mood video out of view')
        this.unloadVideo()
      })
    }
  }

  unloadVideo () {
    this.targetZone.innerHTML = ''
    this.targetZone.loading = false
    this.targetZone.classList.remove('media-block__video--loaded')
    if (this.imageBlock !== null) {
      this.imageBlock.dataset.videoLoaded = false
    }
  }

  loadVideo () {
    this.targetZone.loading = true
    requestAnimationFrame(() => {
      const videoSource = this.compileVideoSource()
      if (videoSource) {
        this.addFrame(videoSource)
        this.targetZone.classList.remove('loading')
        this.targetZone.dataset.videoLoaded = true
        if (this.imageBlock !== null) {
          this.imageBlock.dataset.videoLoaded = true
        }
      }
    })
  }

  compileVideoSource () {
    switch (this.videoType) {
      case 'youtube':
        return `https://www.youtube.com/embed/${this.videoId}?autoplay=1&rel=0&showinfo=0&controls=0&mute=1&loop=1&playlist=${this.videoId}`
      case 'vimeo':
        return `https://player.vimeo.com/video/${this.videoId}?autoplay=1&title=0&byline=0&portrait=0&loop=1&muted=1&controls=0`
      default:
        return false
    }
  }

  addFrame (videoSource) {
    const iframe = document.createElement('iframe')
    iframe.setAttribute('frameborder', '0')
    iframe.setAttribute('allowfullscreen', '')
    iframe.setAttribute('title', 'LeShuttle video')
    iframe.setAttribute('allow', 'autoplay; fullscreen')
    iframe.setAttribute('src', videoSource)
    iframe.classList.add('media-block__iframe')
    this.targetZone.appendChild(iframe)
    this.targetZone.classList.add('media-block__video--loaded')
    iframe.focus()
  }
}

export const setupDynamicVideoButtons = function (parent) {
  const buttons = parent.querySelectorAll('button[data-dynamic-embed]')
  const dynamicVideoButtons = []

  for (const button of buttons) {
    dynamicVideoButtons.push(new DynamicVideoEmbed(button))
  }
  return dynamicVideoButtons
}

export const setupMoodVideos = function (parent) {
  const videos = parent.querySelectorAll('[data-video-autoplay]')
  const moodVideos = []

  for (const video of videos) {
    moodVideos.push(new MoodVideo(video))
  }
  return moodVideos
}
